import { useState, useEffect } from "react";
import { Download } from "lucide-react";

const InstallButton = () => {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) setInstalled(true);

    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  if (installed || !deferred) return null;

  return (
    <button
      onClick={install}
      data-testid="btn-installa-app"
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[#1C3F35] text-white text-sm font-medium hover:bg-[#132A23] transition-colors hover:-translate-y-0.5"
    >
      <Download className="w-4 h-4" strokeWidth={1.8} />
      <span className="hidden sm:inline">Installa app</span>
    </button>
  );
};

export default InstallButton;
